import { jsx as _jsx } from "react/jsx-runtime";
import { Check } from "@air/next-icons";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
export const getCustomFieldsFilterOptions = (param)=>{
    let { customFields, selectedFilters, onSelect } = param;
    return customFields.map((field)=>{
        const isFieldSelected = selectedFilters.some((param)=>{
            let { type, customField } = param;
            return type === "customField" && !!customField && field.id === (customField === null || customField === void 0 ? void 0 : customField.id);
        });
        const Icon = customFieldIconMap[field.type.title];
        return {
            disabled: isFieldSelected,
            id: field.id,
            label: field.name,
            onSelect: ()=>onSelect("customField", field),
            "data-testid": "customField-".concat(field.id),
            prefix: /*#__PURE__*/ _jsx(Icon, {
                width: 16
            }),
            suffix: isFieldSelected ? /*#__PURE__*/ _jsx(Check, {
                className: "size-4 text-pigeon-500"
            }) : null,
            type: "item"
        };
    });
};
